// extracted by mini-css-extract-plugin
module.exports = {"groups-steps":"CreateReportSideBar_groups-steps__29_1N","active":"CreateReportSideBar_active__3sHqQ","reports-details":"CreateReportSideBar_reports-details__3uesx"};